import ProfilePicture from "@/components/common/profile-picture";
import { formatViews } from "@/lib/utils";
import { TDiscoverCommunity } from "@/types/community";
import { DotIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

const CommunityCard = ({ communityCardInfo }: { communityCardInfo: TDiscoverCommunity }) => {
	const primaryModerator = communityCardInfo.moderators[0];

	return (
		<div className="relative overflow-hidden rounded-lg bg-white pb-40 shadow-md sm:pb-28 3xl:pb-32">
			<Link href={`/communities/${communityCardInfo.slug}`}>
				<Image
					width={1080}
					height={1080}
					alt={communityCardInfo.name}
					src={communityCardInfo.coverImage || "/placeholder.svg"}
					className="h-24 w-full object-cover md:h-32"
				/>

				<div className="relative flex items-center gap-4 px-4">
					<div className="absolute -top-6 left-4">
						<div className="h-16 w-16 overflow-hidden rounded-xl bg-white p-1 shadow-md">
							<Image
								src={communityCardInfo.logo || "/placeholder.svg"}
								alt={communityCardInfo.name}
								width={1080}
								height={1080}
								className="h-full w-full object-cover"
							/>
						</div>
					</div>

					<div className="flex flex-col pt-3">
						<h3
							className="pl-20 text-sm font-semibold text-gray-900 md:text-base"
							dangerouslySetInnerHTML={{ __html: communityCardInfo.name }}
						/>

						<p
							className="mt-3 line-clamp-4 text-sm text-gray-600"
							dangerouslySetInnerHTML={{ __html: communityCardInfo.description }}
						/>
					</div>

				</div>
			</Link>

			<div className="absolute bottom-0 left-0 right-0">
				<div className="flex flex-wrap items-center gap-px px-4 pb-3">
					<p className="text-sm text-gray-600">Private</p>

					<DotIcon className="h-5 w-5" />

					<p className="text-sm text-gray-600">
						{formatViews(communityCardInfo.totalMembers)} Members
					</p>
				</div>

				{primaryModerator ? (
					<Link
						key={primaryModerator.id}
						href={`/user/${primaryModerator.username}`}
						className="mx-auto flex items-center gap-2 bg-brand-primary/10 px-4 py-2"
					>
						<ProfilePicture
							isFounder={primaryModerator.isFounder}
							isVerified={primaryModerator.isVerified}
							profilePictureUrl={primaryModerator.image}
							className={{
								container: "h-fit w-12 rounded-full p-1",
								image: "rounded-full text-gray-600",
								badgeImage: "-bottom-4 h-7 w-7",
							}}
						/>

						<div className="flex flex-col gap-0.5">
							<p className="text-sm font-semibold text-gray-900">
								{primaryModerator.name || "User"}
							</p>

							<p className="text-xs text-gray-600">
								{primaryModerator.jobTitle} | {primaryModerator.company}
							</p>
						</div>
					</Link>
				) : null}
			</div>
		</div>
	);
};

export default CommunityCard;
